import Rellax from 'rellax';

import Component from '../Component';
import { Breakpoints } from '../constants';

export default class Parallax extends Component {
  /**
   * @param {import('../ThemeBase').default} theme
   * @param {HTMLElement} element
  */
  constructor(theme, element) {
    super(theme, element);

    /** @type {Rellax[]} */
    this.rellaxes = [];

    this.element = element;

    if (!this.isMobile()) {
      this.init();
    }
  }

  init = () => {
    if(this.element.querySelector('.rellax')) {
      this.rellaxes = Array.prototype.map.call(
        this.element.querySelectorAll('.rellax'),
        (el) => {
          return new Rellax(el, {
            center: true,
          });
        },
      );
    }
  }

  destroy = () => {
    this.rellaxes.forEach(
      rellax => rellax.destroy(),
    );
    this.rellaxes = [];
  }

  isMobile = (breakpoint = null) => {
    return (breakpoint || this.theme.getBreakpoint()).order < Breakpoints.md.order;
  }

  onWindowResizeBreakpoint = ({ breakpoint }) => {
    const isMobile = this.isMobile(breakpoint);
    if (!isMobile && this.rellaxes.length === 0) {
      // We're on desktop and parallax is not active => activate it
      this.init();
    } else if (isMobile && this.rellaxes.length > 0) {
      // We're on mobile and parallax is active => deactivate it
      this.destroy();
    }
  }
}
